import NumberField from '../../shared/NumberField'
import React from 'react'
import {
  useWatch,
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../..'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<FormValues>
  trigger: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}
const ExpandabilitySqr = (props: Props) => {
  const { t } = useTranslation()
  const { control, trigger, getValues } = props

  const watch = useWatch({ control, name: 'property.extras.expandability' })

  React.useEffect(() => {
    trigger('property.expandabilitySqr')
  }, [watch, trigger])

  return (
    <NumberField
      title="createPropertyAdFields.expandabilitySqr.label"
      titleProps={{ required: false }}
      translateTitle
      control={control}
      name={'property.expandabilitySqr' as Path<FormValues>}
      rules={{
        validate: {
          dependant: (v) => {
            const dep = getValues('property.extras.expandability')
            if (dep !== 'expandability' && !!v) {
              return t('manageEstateAd.mustNotHaveValue') as unknown as string
            }
            return true
          },
        },
      }}
    />
  )
}

export default ExpandabilitySqr
